import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'pages.settings.sections.general.title',
    defaultMessage: 'General',
    description: 'title of the general section on the settings page',
  },
  settings: {
    showItemsAllButton: {
      id: 'pages.settings.sections.general.settings.showItemsAllButton',
      defaultMessage: 'Visibility settings all button',
      description: 'Title of the show all button on mobile setting',
    },
    minRequestedQuantity: {
      id: 'pages.settings.sections.general.settings.minRequestedQuantity',
      defaultMessage: 'Minimum quantity to pick',
      description: 'Title of the minimum requested quantity setting',
    },
    atLeastOneProductManually: {
      id: 'pages.settings.sections.general.settings.atLeastOneProductManually',
      defaultMessage: 'Pick at least one product manually',
      description: 'Title of the at least one product manually setting',
    },
    showPositionSuggestions: {
      id: 'pages.settings.sections.general.settings.showPositionSuggestions',
      defaultMessage: 'Show position suggestions',
      description: 'Title of the show position suggestions setting',
    },
  },
  editItemsAllButtonSettings: {
    title: {
      id: 'pages.settings.sections.general.editItemsAllButtonSettings.title',
      defaultMessage: 'Edit all button settings',
      description: 'Title of the edit all button settings drawer',
    },
  },
  actions: {
    edit: {
      id: 'actions.edit',
      defaultMessage: 'Edit',
      description: 'Label of the edit action',
    },
  },
  feedback: {
    settingsUpdated: {
      id: 'pages.settings.feedback.settingsUpdated',
      defaultMessage: 'Settings updated',
      description: 'Success message of the update settings action',
    },
    settingsNotUpdated: {
      id: 'pages.settings.feedback.settingsNotUpdated',
      defaultMessage: 'Settings could not be updated',
      description: 'Error message of the update settings action',
    },
  },
};

export default defineMessages(translations);
